export default async supertruck => {

    //----Functions----//

    //Remove an Existing Class
    function removeClass(element, targetClass) {
        if (element.classList.contains(targetClass)) {
            element.classList.remove(targetClass);
        }
    }

    //Add Additional Classes Via Array
    function addClass(element, classArray) {
        for (const item of classArray) {
            element.classList.add(item);
        }
    }

    //Shorthand for Selection Query
    function select(query) {
        return document.querySelectorAll(query)
    }

    //Selector Definitions
    const videoModuleQuery = select('.truck-media-container .truck-media .media-video');
    const videoModules = (videoModuleQuery) ? videoModuleQuery : undefined;    
    let videoBulk = select(".hero-full");
 
    //Changes Begin
    if (window.location.href.indexOf("supertruck") > -1
        || window.location.href.indexOf("super-truck") > -1) {

        //--Overrides--//

        //Mobile Padding Fix - Replace if time allows
        addClass(document.body, ["sm:tw-mx-16", "md:tw-mx-0"])

        if (videoModules !== undefined) {

            for (let i = 0, l = videoModules.length; i < l; i++) {

                addClass(videoModules[i], ["tw-flex"]);

                const images = videoModules[i].querySelectorAll('img')

                if (images)
                    for (let ii = 0, ll = images.length; ii < ll; ii++)
                        images[ii].style.display = 'none';

                const videos = videoModules[i].querySelectorAll('video');

                if (videos)
                    for (let ii = 0, ll = videos.length; ii < ll; ii++)
                        addClass(videos[ii], ["tw-max-w-[1380px]", "tw-m-auto"]);
            }
        }

        //--Secondary Video Modules//
        for (let i = 0; i < videoBulk.length; i++) {
            addClass(videoBulk[i], ["tw-max-w-[1340px]","tw-mx-auto","tw-block","tw-my-4"])
        }
                                
    }
   //Changes End
}